// TODO - Papa-fy this code
'use strict';
angular.module('dat.shared-components.location')
	.factory('baseValidator', ['$q', 'LocationService', function baseValidatorFactory($q, locationService) {

		var baseValidator;

		function validationResult() {
			return {
				data: {
					isValid: true,
					isUnusual: false,
					message: ''
				},

				setInvalid: function(msg) {
					this.data.isValid = false;
					this.data.message = msg;
				},

				setRequired: function (msg, required) {
					if (required) {
						this.setInvalid(msg);
					}
					this.data.isEmpty = true;
				}
			};
		}

		function trim(value) {
			return value.toString().replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ');
		}

		function isEmpty(value) {
			if (value === null || value === undefined)
				return true;

			return trim(value).length == 0;
		}

		baseValidator = {
			clearValidation: function(model, field){
				var validator = model[field + 'Validation'];

				if (validator !== undefined){
					validator.message = '';
					validator.invalid = false;
				}
			},

			resolveLocation: function (locationType, value, trimmedValue, includeAreas, fnSuccess, fnError) {
				var encodedValue = encodeURIComponent(trimmedValue);
				var endPointUrl = '../api/location/resolve?term=' + encodedValue + '&includeAreas=' + includeAreas;

				return locationService.resolveLocation(endPointUrl, fnSuccess, fnError);
			},

			validateLocation: function(locationType, value, includeAreas) {
				var deferred = $q.defer(),
					result;
				var trimmedValue = $.trim(value);

				function isOrigin() {
					return locationType === 'origin';
				}

				result = validationResult();

				if (isEmpty(trimmedValue)) {
					if (isOrigin()) {
						result.setRequired('Origin is required', true);
					} else {
						result.setRequired('Destination is required', true);
					}

					deferred.resolve(result.data);
				} else {
					baseValidator.resolveLocation(locationType, value, trimmedValue, includeAreas,
						function(response) {
							if (response.isValid) {
								result.data.locationResolution = response.handle;
								result.data.isArea = response.isArea;
								result.data.enteredValue = trimmedValue;
								result.data.coordinates = response.coordinates;
								result.data.formattedLocation = response.value;
							} else {
								if (isOrigin()) {
									result.setInvalid('Origin ' + trimmedValue + ' is invalid');
								} else {
									result.setInvalid('Destination ' + trimmedValue + ' is invalid');
								}
							}
							deferred.resolve(result.data);
						},
						function() {
							result.setInvalid('Unknown error');
							deferred.resolve(result.data);
						}
					);

				}

				return deferred.promise;
			},

			makeValidationResultForGivenLocation: function(handle, formattedLocation, isArea) {
				var deferred = $q.defer(), result;
				result = validationResult();
				result.data.isEmpty = false;
				result.data.locationResolution = handle;
				result.data.formattedLocation = formattedLocation;
				result.data.isArea = isArea;
				deferred.resolve(result.data);

				return deferred.promise;
			}
		};

		return baseValidator;
	}]
	);
